package org.solyton.solawi.bid.application.ui.effect

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.evoleq.compose.Markup
import org.evoleq.compose.style.data.device.DeviceType
import org.evoleq.device.data.Device
import org.evoleq.device.data.mediaType
import org.evoleq.device.data.screenWidth
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.transform.times

@Markup
@Composable
@Suppress("FunctionName")
fun LaunchSetDeviceData(deviceData: Storage<Device>) {
    LaunchedEffect(Unit) {
        launch {
            if((deviceData * mediaType).read() is DeviceType.Empty) {
                (deviceData * screenWidth).write(window.innerWidth.toDouble())
                (deviceData * mediaType).write(
                    DeviceType.detect(
                        width = window.innerWidth.toDouble(),
                        userAgent = window.navigator.userAgent,
                        hasTouch = js("navigator.maxTouchPoints > 0") as Boolean,
                        maxTouchPoints = js("navigator.maxTouchPoints") as Int
                    )
                )
            }
            window.addEventListener("resize", {
                (deviceData * screenWidth).write(window.innerWidth.toDouble())
                (deviceData * mediaType).write(
                    DeviceType.detect(
                        width = window.innerWidth.toDouble(),
                        userAgent = window.navigator.userAgent,
                        hasTouch = js("navigator.maxTouchPoints > 0") as Boolean,
                        maxTouchPoints = js("navigator.maxTouchPoints") as Int
                    )
                )
            })
        }
    }
}
